import React from 'react';
import styled from 'styled-components';
import Container from '../../../../../../components/container';
import Box from '../../../../../../components/box';
import { H3, Cols } from '../../../../components';
import CustomButton from '../../../../../forgot-password/CustomButton';

const ItemStyled = styled(Box)`
  // height: 415px;heightheightheightheightheightheightheightheightheightheightheightheightheightheightheightheight
`;

const ItemTitleStyled = styled(Box)`
  font-size: 20.5px;
  line-height: 1.51;
  letter-spacing: 1.03px;
  text-align: center;
  color: #3b3939;

  @media (min-width: 768px) {
    min-height: 150px;
  }
`;

const ItemQuoteStyled = styled(Box).attrs(props => ({
  children: props.left ? '«' : '»',
  component: "span",
}))`
  font-size: 31px;
  font-weight: 900;
  letter-spacing: 1.55px;
  color: #145a8f;
`;

const DeviderStyled = styled(Box)`
  width: 129px;
  height: 2px;
  background-color: #797979;
  margin: auto;
`;

const ItemProfileBlockStyled = styled(Box)`
  transform: translate(0, 35px);
`;

const ItemProfileNameStyled = styled(Box)`
  font-size: 14px;
  font-weight: 900;
  line-height: 1.46;
  letter-spacing: 0.35px;
  text-align: center;
  color: #3b3939;
`;

const ItemProfilePositionStyled = styled(ItemProfileNameStyled)`
  color: #145a8f;
`;

const ItemProfileImageStyled = styled(Box).attrs({component: "img"})`
  max-width: 100%;
`;

const Item = ({title, name, position, imageSrc, ...rest}) => (
  <ItemStyled backgroundWhite px={4} pt={4} flex flexDirectionColumn height="100%" {...rest}>
    <ItemTitleStyled f={1}>
      <ItemQuoteStyled left />&nbsp;{title}&nbsp;<ItemQuoteStyled />
    </ItemTitleStyled>

    <ItemProfileBlockStyled>
      <DeviderStyled mb={5} />

      <ItemProfileNameStyled>{name}</ItemProfileNameStyled>

      <ItemProfilePositionStyled>{position}</ItemProfilePositionStyled>

      <ItemProfileImageStyled src={process.env.NEXT_PUBLIC_PUBLIC_URL + imageSrc} mt={2} />
    </ItemProfileBlockStyled>
  </ItemStyled>
)


const ITEMS = [
  (
    <Item
      title="Le meilleur et le plus intéressant job étudiant que j’ai fait."
      name="JOSÉPHINE"
      position="LA SORBONNE"
      imageSrc="/img/cours/private/profile-1.png"
    />
  ),

  (
    <Item
      title="J'ai trouvé très vite 3 élèves dont l’un dans ma rue."
      name="LÉA"
      position="SCIENCES PO"
      imageSrc="/img/cours/private/profile-2.png"
    />
  ),

  (
    <Item
      title="Les cours se passent  bien et avec Clevermate c’est toujours simple et pratique."
      name="ANTOINE"
      position="CENTRALE LYON"
      imageSrc="/img/cours/private/profile-3.png"
    />
  )
].map(description => ({description, descriptionProps: {mt: 0, height: '100%'}}));

function CommentsSection({title, ...rest}) {
  return (
    <Container {...rest} pb={0}>
      <H3 lineBlue>{title}</H3>

      <Cols items={ITEMS} />
      <a  href="/sign-up#signupTutor" style={{ display: 'block', width: 256, margin: '97px auto 0 auto' }}>
      <CustomButton color="secondary" style={{ padding: 16, borderRadius: 48 }}>
          Devenir Tuteur
        </CustomButton>
      </a>
    </Container>
  )
}

CommentsSection.defaultProps = {
  title: 'Que disent les profs particuliers de Clevermate ?',
};

export default CommentsSection;